import { useRoutes } from 'react-router-dom';

import { ScrollToTop } from '@/components/Navigation/ScrollToTop';
import { lazyImport } from '@/utils/lazyImport';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

const { ErrorPagesRoutes } = lazyImport(() => import('@/features/errorPages'), 'ErrorPagesRoutes');

export const AppRoutes = () => {
  const errorPagesRoutes = [
    {
      path: '/error/*',
      element: <ErrorPagesRoutes />,
    },
  ];

  const routes = [...protectedRoutes, ...publicRoutes];

  const element = useRoutes([...errorPagesRoutes, ...routes]);

  return (
    <>
      <ScrollToTop>{element}</ScrollToTop>
    </>
  );
};
